var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitorCountHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.998,
    height: 23.004,
    viewBox: "0 0 21.998 23.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16050",
    "data-name": "Group 16050",
    transform: "translate(-190.002 -287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Visitor",
    d: "M14754.891-14600a.713.713,0,0,1-.092,0,3.9,3.9,0,0,1-2.655-1.141,3.884,3.884,0,0,1-1.142-2.758v-2.031a.845.845,0,0,1,.845-.849.847.847,0,0,1,.85.849v2.031a2.218,2.218,0,0,0,.645,1.561,2.233,2.233,0,0,0,.8.511,6.042,6.042,0,0,1,2.182-3.376,7.609,7.609,0,0,1,4.675-1.724,7.623,7.623,0,0,1,4.674,1.724,6.052,6.052,0,0,1,2.185,3.376,2.189,2.189,0,0,0,.8-.511,2.2,2.2,0,0,0,.646-1.561v-2.031a.849.849,0,0,1,.849-.849.846.846,0,0,1,.849.849v2.031a3.9,3.9,0,0,1-1.142,2.758,3.9,3.9,0,0,1-2.654,1.141.729.729,0,0,1-.093,0Zm3.039-9.126a4.359,4.359,0,0,1-1.271-3.069,4.347,4.347,0,0,1,1.271-3.07,4.345,4.345,0,0,1,3.07-1.271,4.322,4.322,0,0,1,1.66.33,4.326,4.326,0,0,1,1.409.941,4.31,4.31,0,0,1,.941,1.405,4.343,4.343,0,0,1,.33,1.665,4.337,4.337,0,0,1-.33,1.66,4.368,4.368,0,0,1-.941,1.409,4.373,4.373,0,0,1-1.409.941,4.4,4.4,0,0,1-1.66.33A4.361,4.361,0,0,1,14757.93-14609.122Zm11.374-4.945v-2.035a2.2,2.2,0,0,0-.646-1.558,2.2,2.2,0,0,0-1.557-.645h-3.051a.849.849,0,0,1-.85-.849.848.848,0,0,1,.85-.846h3.051a3.906,3.906,0,0,1,2.758,1.142,3.9,3.9,0,0,1,1.142,2.755v2.035a.846.846,0,0,1-.849.849A.849.849,0,0,1,14769.3-14614.067Zm-18.3,0v-2.035a3.889,3.889,0,0,1,.3-1.49,3.866,3.866,0,0,1,.846-1.265,3.834,3.834,0,0,1,1.264-.845,3.876,3.876,0,0,1,1.49-.3h3.051a.846.846,0,0,1,.85.846.846.846,0,0,1-.85.849h-3.051a2.182,2.182,0,0,0-.841.171,2.16,2.16,0,0,0-.716.474,2.23,2.23,0,0,0-.479.716,2.182,2.182,0,0,0-.166.842v2.035a.847.847,0,0,1-.85.849A.845.845,0,0,1,14751-14614.067Z",
    transform: "translate(-14561 14910)",
    fill: "#f2824c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4060",
    "data-name": "Ellipse 4060",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(204 287)",
    fill: "#f2824c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorCountHover);
export default __webpack_public_path__ + "static/media/visitorCountHover.2509230bd413d6cbd798774bac17959b.svg";
export { ForwardRef as ReactComponent };